module.exports = new __parcel__URL__("reservoir-dogs.354c797a.jpg").toString();